import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Yearlycorporatecabrentalsinmumbai() {



  const cardData =
  {
    keyword: 'Yearly Corporate Cab Rentals in Mumbai',
    heading: 'Aaryan Travels: Yearly Corporate Cab Rentals in Mumbai',
    headingDescription: 'Aaryan Travels offers Yearly Corporate Cab Rentals in Mumbai for businesses and executives seeking long-term transportation solutions with complete convenience and cost-efficiency. Whether it’s employee commuting, executive allocation, airport transfers, or intercity business travel, our fleet of sedans, SUVs, and premium vehicles is available on annual rental contracts with structured billing. With uniformed chauffeurs, GPS-enabled vehicles, timely reporting, and 24/7 support, we ensure uninterrupted mobility across Andheri, BKC, Navi Mumbai, Thane, and South Mumbai. Aaryan Travels eliminates the hassle of repetitive bookings by providing reliable yearly cab rental solutions tailored to your corporate transportation needs in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 by the Arabian Sea, is Mumbai’s most recognizable monument. Originally constructed to welcome British royalty, it now serves as a major tourist hub. Visitors enjoy ferry rides to Elephanta Caves and panoramic sea views. Lit up at night, it creates a majestic coastal backdrop. Gateway of India is Mumbai’s historic symbol of pride and grandeur."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km-long coastal promenade that glows with necklace-shaped lights at night. Locals visit for sunset walks, street snacks, and peaceful sea gazing. The cool breeze and soothing waves make it a favorite leisure spot. Marine Drive is Mumbai’s timeless stretch of serenity."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO-recognized railway station built in 1887, showcasing Victorian Gothic architecture. Its stained-glass windows, domes, and arches make it look like a royal palace. Although a functional transport hub, it remains a heritage marvel. At night, the illuminated façade is breathtaking. CST is Mumbai’s iconic blend of history and motion."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular sandy escape, filled with street food stalls serving pav bhaji, bhel puri, and ice gola. Families, joggers, and tourists gather here to enjoy sea views and camel rides. The area is also known for celebrity homes nearby. Juhu Beach is Mumbai’s lively coastal carnival."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb set on a small islet in the Arabian Sea, connected by a narrow causeway. During high tide, it appears to float on water. Devotees of all faiths visit to seek blessings and listen to soulful qawwalis. Haji Ali is Mumbai’s sacred island of spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th century. They feature magnificent stone sculptures of Lord Shiva, including the famous Trimurti. A ferry ride from Gateway of India adds adventure to the trip. Elephanta Caves are Mumbai’s ancient masterpiece carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered temples dedicated to Lord Ganesha. Devotees, including film stars and politicians, line up daily to seek blessings. The gold-plated dome and intricately adorned idol radiate divine grace. Siddhivinayak is Mumbai’s spiritual powerhouse."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting South Mumbai to its western suburbs. Driving across offers panoramic views of the sea and skyline. Illuminated at night, the bridge looks futuristic and grand. It has significantly reduced travel time. The Sea Link is Mumbai’s symbol of innovation and progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a buzzing street market famous for trendy clothes, jewelry, and antique souvenirs. Bargain shopping and street food make it a must-visit for tourists. Iconic cafés like Leopold Café add vintage charm. Colaba Causeway is Mumbai’s vibrant bazaar of fashion and flavors."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering safaris, trekking trails, and boating. The ancient Kanheri Caves inside the park provide historical intrigue. Visitors often spot deer, monkeys, and colorful birds. SGNP is Mumbai’s refreshing wilderness escape."
  }
],



  "services": [
  {
    "name": "Yearly Corporate Cab Rentals in Mumbai",
    "description": "Yearly Corporate Cab Rentals in Mumbai provide comprehensive transportation solutions for businesses requiring long-term, reliable cab services. With a focus on consistent quality and professional drivers, companies can benefit from fixed annual pricing, guaranteed vehicle availability, and flexible usage tailored to employee schedules and corporate events. This service ensures seamless mobility for your workforce throughout the year, minimizing administrative hassle and enhancing operational efficiency."
  },
  {
    "name": "Annual Cab Subscription Mumbai",
    "description": "Annual Cab Subscription Mumbai offers businesses a convenient and cost-effective way to manage employee and executive travel with a yearly plan. This subscription service covers daily commutes, client meetings, and occasional trips, ensuring punctuality and safety. With customizable packages and dedicated support, companies can scale transport services based on changing needs while enjoying predictable monthly billing."
  },
  {
    "name": "Long Term Corporate Cab Mumbai",
    "description": "Long Term Corporate Cab Mumbai caters to organizations that require dependable cab services for extended durations beyond monthly rentals. The service includes chauffeur-driven sedans and SUVs, regular maintenance, and priority customer support, all designed to facilitate hassle-free employee transportation and client travel. It is ideal for businesses looking to optimize their transport budgets without compromising on service quality."
  },
  {
    "name": "12 Month Cab Hire Mumbai",
    "description": "12 Month Cab Hire Mumbai delivers fixed-term vehicle rental solutions with professional chauffeurs, enabling businesses to secure transport for an entire year. This plan offers flexible vehicle options, including luxury sedans and executive cars, with maintenance and driver management handled by the service provider. It helps companies maintain consistent mobility for staff and executives while controlling costs and logistics efficiently."
  },
  {
    "name": "Corporate Vehicle Lease Mumbai",
    "description": "Corporate Vehicle Lease Mumbai provides long-term leasing options for businesses seeking to avoid the complexities of vehicle ownership. The lease includes chauffeur services, full maintenance, insurance, and vehicle replacement, making it a comprehensive solution for employee transportation. This approach frees companies from fleet management responsibilities while ensuring high standards of service and reliability."
  },
  {
    "name": "Business Cab Yearly Plan Mumbai",
    "description": "Business Cab Yearly Plan Mumbai is designed for companies that prefer an all-inclusive yearly contract for their corporate transportation needs. With dedicated vehicles and experienced drivers assigned exclusively to the business, this plan enhances security, privacy, and service consistency. It supports multiple routes, shift schedules, and special travel requests, making it highly adaptable to diverse organizational requirements."
  },
  {
    "name": "Chauffeur Cab Mumbai Yearly",
    "description": "Chauffeur Cab Mumbai Yearly delivers premium chauffeur-driven transportation services on an annual basis, ideal for executive travel and VIP client conveyance. Professional drivers trained in corporate etiquette ensure a refined travel experience, while the service guarantees vehicle cleanliness, punctuality, and safety throughout the contract term. This service elevates the company's image by offering seamless and luxurious travel solutions."
  },
  {
    "name": "Company Transport Mumbai",
    "description": "Company Transport Mumbai offers end-to-end solutions for employee commuting and business travel, structured around yearly or long-term contracts. This service manages fleet deployment, route optimization, and driver training to provide safe, timely, and comfortable rides. It is perfect for large organizations aiming to streamline their staff transportation while reducing overheads and improving overall operational efficiency."
  },
  {
    "name": "Office Travel Cab Mumbai",
    "description": "Office Travel Cab Mumbai specializes in daily employee transportation with yearly contracts that ensure reliable, punctual service aligned with company shift timings. Vehicles are regularly inspected and drivers are trained for safety and professionalism. The service can be tailored to accommodate multiple office locations, varying start and end times, and emergency transport needs, making it an indispensable part of corporate logistics."
  },
  {
    "name": "Employee Transport Yearly Mumbai",
    "description": "Employee Transport Yearly Mumbai is a dedicated service focused on providing long-term transport arrangements for company staff. It emphasizes safety protocols, consistent vehicle availability, and cost control through fixed yearly contracts. The service supports scalable fleet sizes and can incorporate last-minute changes, making it flexible enough for both small startups and large enterprises."
  },
  {
    "name": "Affordable Annual Cab Rental Mumbai",
    "description": "Affordable Annual Cab Rental Mumbai blends budget-conscious pricing with reliable, high-quality corporate transport. Designed for startups and SMEs, this service delivers dependable vehicles and professional drivers under yearly rental agreements. It prioritizes cost efficiency without compromising on safety, cleanliness, or timeliness, offering a smart solution for businesses managing tight budgets."
  },
  {
    "name": "Executive Taxi Mumbai",
    "description": "Executive Taxi Mumbai provides luxurious and discreet taxi services for business leaders and senior executives on yearly contracts. Featuring premium vehicles, trained chauffeurs, and priority support, the service focuses on comfort, privacy, and punctuality. It is ideal for corporate travel, airport transfers, and high-profile meetings, enhancing the executive travel experience."
  },
  {
    "name": "Yearly Cab Booking Mumbai",
    "description": "Yearly Cab Booking Mumbai simplifies corporate transport management with a comprehensive annual reservation system. Businesses can secure dedicated vehicles and drivers for the entire year, enabling easy planning and budgeting. The service includes digital tracking, customer support, and flexible rescheduling options to accommodate dynamic business requirements."
  },
  {
    "name": "Premium Corporate Cab Mumbai",
    "description": "Premium Corporate Cab Mumbai specializes in upscale corporate transportation on long-term contracts, offering luxury vehicles and exceptional service standards. The fleet includes executive sedans, SUVs, and premium cars with chauffeur services, ensuring clients travel in style and comfort. This service is tailored for companies aiming to impress clients and executives with superior transport solutions."
  },
  {
    "name": "Best Long Duration Cab Mumbai",
    "description": "Best Long Duration Cab Mumbai delivers trusted and consistent transport services for companies needing reliable cabs over extended periods. With experienced drivers, well-maintained vehicles, and customer-centric policies, this service guarantees smooth operations for daily commutes, corporate events, and business travel throughout the year."
  }
],
"tableData": [
  ["Yearly Corporate Cab Rentals in Mumbai", "Annual Cab Subscription Mumbai"],
  ["Long Term Corporate Cab Mumbai", "12 Month Cab Hire Mumbai"],
  ["Corporate Vehicle Lease Mumbai", "Business Cab Yearly Plan Mumbai"],
  ["Chauffeur Cab Mumbai Yearly", "Company Transport Mumbai"],
  ["Office Travel Cab Mumbai", "Employee Transport Yearly Mumbai"],
  ["Affordable Annual Cab Rental Mumbai", "Executive Taxi Mumbai"],
  ["Yearly Cab Booking Mumbai", "Premium Corporate Cab Mumbai"],
  ["Best Long Duration Cab Mumbai", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Yearly Corporate Cab Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers dependable yearly corporate cab rentals in Mumbai, providing seamless transportation solutions for your business needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs ensure punctual, courteous, and safe rides throughout the year to support your corporate schedule."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs that are regularly serviced to guarantee comfort and safety."
  },
  {
    "WhyChooseheading": "Drivers Knowledgeable of Mumbai’s Routes",
    "WhyChoosedescription": "Our drivers are familiar with Mumbai’s traffic patterns and best routes to ensure efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Annual Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from fixed yearly pricing inclusive of fuel, tolls, and driver allowances for hassle-free budgeting."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, changes, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible and Customizable Rental Plans",
    "WhyChoosedescription": "Tailor your yearly rental plan to match your company’s specific transportation needs and preferences."
  },
  {
    "WhyChooseheading": "Exclusive Corporate Fleet for Yearly Rentals",
    "WhyChoosedescription": "Enjoy priority service with vehicles exclusively allocated to your organization for the entire rental period."
  }
]






















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer yearly corporate cab rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides comprehensive yearly corporate cab rental plans in Mumbai designed to meet your long-term business travel requirements.',
  },
  {
    question: 'How can I book yearly corporate cab rentals in Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team in Mumbai.',
  },
  {
    question: 'What types of vehicles are available for yearly corporate cab rentals in Mumbai?',
    answer: 'Aaryan Travels offers a fleet of well-maintained sedans, SUVs, and premium cars suitable for yearly corporate rentals.',
  },
  {
    question: 'Are drivers experienced and trained for yearly corporate cab rentals in Mumbai?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for yearly rentals in Mumbai?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Mumbai and nearby business areas.',
  },
  {
    question: 'Is the yearly corporate cab rental service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab rental services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for yearly corporate cab rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for yearly corporate cab rentals in Mumbai?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the yearly corporate cab rental period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Shah',
    feedback: 'Aaryan Travels provided excellent yearly corporate cab rental services in Mumbai with professional drivers and reliable service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Nair',
    feedback: 'Reliable and efficient yearly corporate cab rentals by Aaryan Travels in Mumbai. Highly recommend for business travel!',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const yearlyCorporateCabMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Yearly Corporate Cab Rentals in Mumbai",
  "description": "Aaryan Travels provides yearly corporate cab rentals in Mumbai with chauffeur-driven cars for long-term business travel, staff transport, and company use. Enjoy reliable and affordable annual cab plans.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Yearly Corporate Cab Rentals",
  "keywords": "Yearly Corporate Cab Rentals in Mumbai, Annual Cab Subscription Mumbai, Long Term Corporate Cab Mumbai, 12 Month Cab Hire Mumbai, Corporate Vehicle Lease Mumbai, Business Cab Yearly Plan Mumbai, Chauffeur Cab Mumbai Yearly, Company Transport Mumbai, Office Travel Cab Mumbai, Employee Transport Yearly Mumbai, Affordable Annual Cab Rental Mumbai, Executive Taxi Mumbai, Yearly Cab Booking Mumbai, Premium Corporate Cab Mumbai, Best Long Duration Cab Mumbai"
};








  return (
    <div>

<Helmet>
  <title>Yearly Corporate Cab Rentals in Mumbai | Long-Term Business Cab Plans | Aaryan Travels</title>
  <meta
    name="description"
    content="Book yearly corporate cab rentals in Mumbai with Aaryan Travels. Long-term chauffeur-driven cabs for companies, staff transport, and executive travel."
  />
  <meta
    name="keywords"
    content="Yearly Corporate Cab Rentals in Mumbai, Annual Cab Subscription Mumbai, Long Term Corporate Cab Mumbai, 12 Month Cab Hire Mumbai, Corporate Vehicle Lease Mumbai, Business Cab Yearly Plan Mumbai, Chauffeur Cab Mumbai Yearly, Company Transport Mumbai, Office Travel Cab Mumbai, Employee Transport Yearly Mumbai, Affordable Annual Cab Rental Mumbai, Executive Taxi Mumbai, Yearly Cab Booking Mumbai, Premium Corporate Cab Mumbai, Best Long Duration Cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(yearlyCorporateCabMumbaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Yearlycorporatecabrentalsinmumbai;